import 'app/mains/generic-static-page-main';
import 'scss/pages/login.scss';
import 'app/libWrappers/i18next.wrapper';
import React, { Suspense } from 'react';
import $ from 'jquery';
import { renderComponentWithProviders } from 'app/common/ReactDomWrapper';
import Loader from 'app/common/components/loading/Loader';
import CustomerSupportBox from 'app/common/components/customerSupport/CustomerSupportBox';

const CustomerSupportBoxContainer = () => {
    return (
        <Suspense fallback={<Loader loading />}>
            <CustomerSupportBox className="customer-support--login-page" hideHelp />
        </Suspense>
    );
};

$(document).ready(() => {
    renderComponentWithProviders(CustomerSupportBoxContainer, $('.customer-support-info')[0]);
});
